import { lazy } from "@bridgesplit/ui";

const Rewards = lazy(() => import("./Rewards"));

export { Rewards };
export * from "./dialog";
export * from "./oauth";
export * from "./app";
export * from "./stats";
export * from "./util";
